import ListItem from "../../../components/ListItem";
import { $ } from "../../../../../vendor";

const HelpMessageListItem = (props) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const toggleElement = (ev, key) => {
    $("#help-message-items-panel-" + key).toggleClass("active");
    $("#reservations-item-" + key).toggleClass("toggled");
    searchParams.set("item", key);
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
  };

  return (
    <>
      <ListItem
        key={props._key}
        listStyle={props.listStyle}
        id={props.id}
        overwriteClasses={props.overwriteClasses}
        elements={props.elements}
        menu={props.menu}
        refLink={props.refLink}
        length={props.length}
        extra9={true}
        toggleElement={toggleElement}
        multipleCheckins={true}
        helpMessageItems={props.helpMessageItems}
        helpMessage={props.helpMessage}
        dispatch={props.dispatch}
      />
    </>
  );
};

export default HelpMessageListItem;